import { ReactNode } from 'react'

import Icon from '../Icon/Icon'
import { T } from '../Text/Text'
import Tooltip from '../Tooltip/Tooltip'

type Props = {
  content: ReactNode
  trigger?: 'click' | 'hover'
}
const QuickTip = ({ content, trigger = 'hover' }: Props) => {
  if (!content) {
    return null
  }

  return (
    <Tooltip content={content} trigger={trigger}>
      <T.Label
        className={`w-fit px-0.5 ${
          trigger === 'click'
            ? 'hover:text-link focus:text-link cursor-pointer rounded-xs outline-offset-[-1px] focus-visible:outline'
            : ''
        }`}
        tabIndex={trigger === 'click' ? 0 : undefined}
        role={trigger === 'click' ? 'button' : undefined}
      >
        <Icon.FaQuestionCircle />
      </T.Label>
    </Tooltip>
  )
}

export default React.memo(QuickTip)
